import React from 'react';
import ResourceComponent from '../../../common/ResourceComponent';
import {Col, DropdownItem, DropdownMenu, DropdownToggle, FormGroup, UncontrolledDropdown} from 'reactstrap';

class SortDropdown extends ResourceComponent {
    getTitle = () => {
        const {filters} = this.props;
        if (filters.sort_by === 'price_low') {
            return 'Price Low - High';
        } else if (filters.sort_by === 'price_high') {
            return 'Price High - Low';
        } else if (filters.sort_by === 'newest') {
            return 'Newest';
        } else if (filters.sort_by === 'oldest') {
            return 'Oldest';
        } else if (filters.sort_by === 'sales') {
            return 'Sale items';
        } else {
            return 'Sort By';
        }
    };

    render() {
        const {filters, changeSort, loading} = this.props;
        return (
            <FormGroup className='mb-0 me-sm-2'>
                <Col className='pr-0'>
                    <UncontrolledDropdown className='float-right'
                                          style={{width: '140px', border: '1px solid lightgrey'}}>
                        <DropdownToggle caret disabled={loading} className='w-100 btn-sm text-left'>
                            Sort By
                        </DropdownToggle>
                        <DropdownMenu className='btn-block' style={{width: 'fit-content'}}>
                            <DropdownItem
                                active={filters.sort_by === 'price_low'}
                                onClick={() => changeSort('price_low')}>
                                Price Low - High
                            </DropdownItem>
                            <DropdownItem divider />
                            <DropdownItem
                                active={filters.sort_by === 'price_high'}
                                onClick={() => changeSort('price_high')}>
                                Price High - Low
                            </DropdownItem>
                            <DropdownItem divider />
                            <DropdownItem
                                active={filters.sort_by === 'newest'}
                                onClick={() => changeSort('newest')}>
                                Newest
                            </DropdownItem>
                            <DropdownItem divider />
                            <DropdownItem
                                active={filters.sort_by === 'sales'}
                                onClick={() => changeSort('sales')}>
                                Sale items
                            </DropdownItem>
                            <DropdownItem divider />
                            <DropdownItem
                                active={filters.sort_by === 'oldest'}
                                onClick={() => changeSort('oldest')}>
                                Oldest
                            </DropdownItem>
                            <DropdownItem divider />
                            <DropdownItem
                                active={filters.sort_by === 'species then numeric asc'}
                                onClick={() => changeSort('species then numeric asc')}>
                                Species then numeric
                            </DropdownItem>
                        </DropdownMenu>
                    </UncontrolledDropdown>
                </Col>
            </FormGroup>
        );
    }
}

export default SortDropdown;


// WEBPACK FOOTER //
// ./src/containers/embeddable/utils/SortDropdown.js